export default {"src":"/_next/static/media/Group 427320988.ec171e43.svg","height":12,"width":10,"blurWidth":0,"blurHeight":0};